import { render, staticRenderFns } from "./TabelaSancoesRestricoesPj.vue?vue&type=template&id=f033390e&lang=pug"
import script from "./TabelaSancoesRestricoesPj.vue?vue&type=script&lang=js"
export * from "./TabelaSancoesRestricoesPj.vue?vue&type=script&lang=js"
import style0 from "./TabelaSancoesRestricoesPj.vue?vue&type=style&index=0&id=f033390e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports